import { Component, OnInit, OnChanges, SimpleChanges, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AgrimotorService } from '../../agrimotor.service';

@Component({
  selector: 'app-ag-vehicle-agricultural',
  templateUrl: './vehicle-agricultural.component.html',
  styleUrls: ['./vehicle-agricultural.component.css', '../../../quote.component.css']
})
export class AgVehicleAgriculturalComponent implements OnInit, OnChanges {
  @Input() vehicle;
  @Input() staticData;
  @Input() authDetails;
  @Input() index;

  frmFields: FormGroup;
  submitted = false;

  constructor(private fb: FormBuilder, private agService: AgrimotorService) { }

  ngOnInit(): void {
    this.buildForm();
    if (this.vehicle) {
      this.patchValues();
    }
    this.frmFields.valueChanges.subscribe(val => {
      if (this.vehicle) {
        Object.assign(this.vehicle, val);
        if (val.extended_use) {
          this.vehicle.extended_use = val.extended_use;
        }
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.frmFields && this.vehicle) {
      this.patchValues();
    }
  }

  buildForm() {
    this.frmFields = this.fb.group({
      is_road_registered: ['', Validators.required],
      registration_number: [''],
      vin: [''],
      make: ['', Validators.required],
      model: ['', Validators.required],
      year: ['', Validators.required],
      body_type: ['', Validators.required],
      value: ['', Validators.required],
      cover_type: ['', Validators.required],
      extended_use: this.fb.group({
        livestock_carriage: [false],
        contract_work: [false],
      }),
      green_card: ['', Validators.required],
      is_registered_owner: ['', Validators.required],
      ownership: [''],
      owner_name: [''],
      is_kept_overnight: ['', Validators.required],
      postcode: [''],
    });
  }

  patchValues() {
    this.frmFields.patchValue({
      is_road_registered: this.vehicle.is_road_registered || '',
      registration_number: this.vehicle.registration_number || '',
      vin: this.vehicle.vin || '',
      make: this.vehicle.make || '',
      model: this.vehicle.model || '',
      year: this.vehicle.year || '',
      body_type: this.vehicle.body_type || '',
      value: this.vehicle.value || '',
      cover_type: this.vehicle.cover_type || '',
      extended_use: {
        livestock_carriage: this.vehicle.extended_use?.livestock_carriage || false,
        contract_work: this.vehicle.extended_use?.contract_work || false,
      },
      green_card: this.vehicle.green_card || '',
      is_registered_owner: this.vehicle.is_registered_owner || '',
      ownership: this.vehicle.ownership || '',
      owner_name: this.vehicle.owner_name || '',
      is_kept_overnight: this.vehicle.is_kept_overnight || '',
      postcode: this.vehicle.postcode || '',
    }, { emitEvent: false });
  }

  get f() { return this.frmFields.controls; }

  lookupVehicle() {
    const regNum = this.frmFields.get('registration_number').value;
    if (regNum) {
      this.agService.getVehicleDetails(regNum, this.authDetails)
        .subscribe((response: any) => {
          if (response.data) {
            this.frmFields.patchValue({
              make: response.data.make || '',
              model: response.data.model || '',
              year: response.data.year || '',
              value: response.data.value || '',
            });
          }
        }, () => { });
    }
  }
}
